import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();
  
  // Hide footer on course learning pages
  const isCourseLearningPage = location.pathname.includes('/courses/') && location.pathname.includes('/learn');
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      {!isCourseLearningPage && <Footer />}
    </div>
  );
};

export default Layout; 